<template>
	<div id="default">
		<router-view class="container view"></router-view>


		<footer class="text-center mt-5 small">
			<router-link class="mx-2 grey" to="/terms-conditions">Terms & Conditions</router-link>
			<router-link class="mx-2 grey" to="/privacy-policy">Privacy Policy</router-link>
		</footer>
	</div>
</template>

<script>
export default {
	name: "DefaultLayout",
}
</script>

<style scoped>
.view {
	min-height: 75vh;
}
</style>